import React from "react";
import { Button } from "@mui/material";
import debounce from "debounce";
import "./MobileWizard.scss";

interface NextButtonProps {
  label: string;
  setActiveStep?: React.Dispatch<React.SetStateAction<number>>;
  createAccount?: () => void;
  createLeague?: () => void;
  disabled?: boolean;
}

const NextButton: React.FC<NextButtonProps> = ({
  label,
  setActiveStep,
  disabled,
  createAccount,
  createLeague,
}) => {
  function handleClick() {
    if (setActiveStep) {
      setActiveStep((prev) => prev + 1);
    } else if (createAccount) {
      createAccount();
    } else if (createLeague) {
      createLeague();
    }
  }
  return (
    <Button
      className="nextButton__root"
      onClick={debounce(handleClick, 500)}
      disabled={disabled}
    >
      {label}
    </Button>
  );
};

export default NextButton;
